import { Box, Col, Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Image } from '@opendoor/atoms/image';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

import { LANDING_MEDIA } from './landingMedia';
import { BODY_COPY, SECTION, SECTION_HEADING, SECTION_INNER } from './landingStyles';

const HomeLoansSavings = () => (
  <Box as="section" className={SECTION}>
    <Row className={cn(SECTION_INNER, 'gap-10 lg:flex-row lg:items-center lg:gap-[52px]')}>
      <Col className="items-start gap-8 lg:w-[626px]">
        <Text as="h2" className={cn(SECTION_HEADING, 'text-od-content-primary')}>
          More savings for your client, fewer surprises for you.
        </Text>
        <Text className={BODY_COPY}>
          No origination fees. No lender fees. No commissions tied to your rate. Choose Opendoor
          Home Loans for even bigger savings on your client&rsquo;s behalf.
        </Text>
        <Button
          href="/home-loans"
          variant="primary"
          className="min-w-[235px]"
          aria-label="Learn more about Opendoor Home Loans"
          analyticsName="cosmos-make-offer-landing-home-loans"
        >
          Learn more
        </Button>
      </Col>
      <Image
        src={LANDING_MEDIA.homeLoans.src}
        alt={LANDING_MEDIA.homeLoans.alt}
        className="w-full rounded-[40px] object-cover lg:h-[534px] lg:w-[529px] lg:shrink-0"
      />
    </Row>
  </Box>
);

export default HomeLoansSavings;
